module.exports = __webpack_public_path__ + "media/images/common/star-gray-5c1bbf2231c4c2ddb5bc8ccc1ff7f3ee.svg";